import React, { useState, useEffect } from "react";
import * as mod from "./../../url";
import axios from "axios";
import {
  Box,
  Text,
  Heading,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
} from "@chakra-ui/react";
import Navbar from "../Navbar/Navbar";
import Sidebar from "../Sidebar";
const storedData = JSON.parse(sessionStorage.getItem("superAdminLawvs"));
const token = storedData?.data?.token;
const config = { headers: { Authorization: `${token}` } };
const SIDEBAR_WIDTH = "250px";
const ContactUs = () => {
  const [contacts, setContacts] = useState([]);

  const getData = async () => {
    try {
      const { data } = await axios.get(
        `${mod.api_url}/api/v1/contactus/get-contactus`,
        config
      );
      setContacts(data.data);
    } catch (error) {
      console.error("Error fetching contacts:", error);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <Navbar />
      <Sidebar />

      <Box mt="70px" ml={{ base: 0, md: SIDEBAR_WIDTH }} p={3}>
        <Box
          textAlign="center"
          mb={6}
          bg="teal.500"
          py={3}
          borderRadius="md"
          color="white"
          boxShadow="md"
        >
          <Heading fontSize="xl">Contact us</Heading>
        </Box>

        <Box
          borderWidth="1px"
          borderRadius="lg"
          overflow="hidden"
          p={4}
          mb={4}
          boxShadow="md"
        >
          <Table variant="striped" colorScheme="gray">
            <Thead bg="teal.500">
              <Tr>
                <Th color="white">SN.</Th>
                <Th color="white">Name</Th>
                <Th color="white">Email</Th>
                <Th color="white">Mobile</Th>
                {/* <Th color="white">Address</Th> */}
                <Th color="white">Message</Th>
                <Th color="white">Created At</Th>
              </Tr>
            </Thead>
            <Tbody>
              {contacts.map((user, index) => (
                <Tr key={user?._id}>
                  <Td>{index + 1}</Td>
                  <Td fontWeight="bold">{user?.name}</Td>
                  <Td>{user?.email}</Td>
                  <Td>{user?.mobile}</Td>
                  <Td>{user?.message || "-"}</Td>
                  <Td>
                    {new Date(user.createdAt).toLocaleString("en-IN", {
                      dateStyle: "medium",
                      timeStyle: "short",
                    })}
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </Box>
      </Box>
    </>
  );
};

export default ContactUs;
